/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Menujobposting2Inputs */

const en_menujobposting2 = /** @type {(inputs: Menujobposting2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Job Postings`)
};

const de_menujobposting2 = /** @type {(inputs: Menujobposting2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stellenangebote`)
};

/**
* | output |
* | --- |
* | "Job Postings" |
*
* @param {Menujobposting2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const menujobposting2 = /** @type {((inputs?: Menujobposting2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Menujobposting2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_menujobposting2(inputs)
	return en_menujobposting2(inputs)
});
export { menujobposting2 as "menuJobPosting" }